module.exports = __webpack_public_path__ + "img/file-icon-generic.b2544c8.svg";